import React from "react"
import { Navigate } from "react-router-dom"
import { setBookingPlatform } from "@/lib/cookies"
import { BOOKING_QUERY_PARAM } from "@/context/booking"

type PlatformRedirectProps = {
  platform: "fb" | "tiktok"
}

/**
 * Component that sets the platform cookie and redirects to home with datban query
 */
const PlatformRedirect: React.FC<PlatformRedirectProps> = ({ platform }) => {
  React.useEffect(() => {
    setBookingPlatform(platform)
  }, [platform])

  return <Navigate to={`/?${BOOKING_QUERY_PARAM}`} replace />
}

export default PlatformRedirect
